<!-- Top navigation button / icon -->
<div
  *ngIf="indicatorState$ | async as indicator"
  class="job-tracker"
  data-testid="header-item-job-tracker"
>
  <ng-container *ngIf="indicator.kind !== 'hidden'">
    <div
      *ngIf="indicator.kind === 'active'"
      class="job-tracker-spinner"
      title="A background job is running"
      (click)="togglePanel()"
      data-testid="job-tracker-btn-spinner"
    >
      <dx-load-indicator height="20" width="20"></dx-load-indicator>
    </div>

    <div *ngIf="indicator.kind === 'done'" class="job-tracker-done">
      <dx-button
        stylingMode="text"
        type="default"
        icon="clock"
        hint="View background jobs"
        (onClick)="togglePanel()"
        [elementAttr]="{ 'data-testid': 'job-tracker-btn-bell' }"
      ></dx-button>
      <span
        *ngIf="indicator.count > 0"
        class="badge badge-danger job-tracker-badge"
        data-testid="job-tracker-badge-count"
      >
        {{ indicator.count }}
      </span>
    </div>
  </ng-container>
</div>

<!-- Panel -->
<div
  *ngIf="isPanelOpen"
  class="job-tracker-panel"
  data-testid="job-tracker-panel"
>
  <div class="col-12">
    <div
      class="d-flex flex-row justify-content-between align-items-center pl-2 pt-2"
    >
      <h4 class="mb-0"><b>Background Jobs</b></h4>
      <dx-button
        class="mr-1"
        type="text"
        icon="clear"
        (onClick)="closePanel()"
        [elementAttr]="{ 'data-testid': 'job-tracker-btn-close-panel' }"
      ></dx-button>
    </div>
    <hr class="mb-2 mt-1" />
    <div style="height: 90vh">
      <ng-container *ngIf="panelItems$ | async as items">
        <div
          *ngIf="!items.length"
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <p class="empty-job-tracker-text">No background jobs right now.</p>
        </div>

        <dx-scroll-view *ngIf="items.length">
          <div
            *ngFor="let item of items; trackBy: trackById"
            class="job-tracker-item"
            [attr.data-testid]="'job-tracker-item-' + item.id"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div
                class="job-tracker-item-main"
                [class.job-tracker-item--clickable]="item.route"
                (click)="onItemClick(item)"
                [attr.data-testid]="'job-tracker-btn-open-' + item.id"
              >
                <h5
                  class="mt-1 mb-0"
                  [attr.data-testid]="'job-tracker-display-label-' + item.id"
                >
                  <b>{{ item.label }}</b>
                </h5>
                <p
                  class="my-1 ml-0 mr-2"
                  [attr.data-testid]="'job-tracker-display-status-' + item.id"
                >
                  {{ item.kindLabel }} &middot; {{ item.statusLabel }}
                </p>
                <p
                  *ngIf="item.statusDetail"
                  class="my-1 ml-0 mr-2 job-tracker-detail"
                  [attr.data-testid]="'job-tracker-display-detail-' + item.id"
                >
                  {{ item.statusDetail }}
                </p>
                <p
                  class="mb-1 ml-0 mr-2 date-font"
                  [attr.data-testid]="'job-tracker-display-started-' + item.id"
                >
                  {{
                    item.startedAt
                      ? (item.startedAt | date: 'short')
                      : 'Just now'
                  }}
                </p>
              </div>
              <dx-button
                icon="clear"
                hint="Dismiss"
                (onClick)="onDismiss(item.id)"
                [elementAttr]="{
                  'data-testid': 'job-tracker-btn-dismiss-' + item.id,
                }"
              ></dx-button>
            </div>
          </div>
        </dx-scroll-view>
      </ng-container>
    </div>
  </div>
</div>

<app-overlay *ngIf="isPanelOpen" (closePopup)="closePanel()"></app-overlay>
